import React from 'react';

import { AnimacaoNaoEncontrado } from 'Component/Animacao';

interface Props {
    carregando: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registros?: any;
    titulo?: string;
    subtitulo?: string;
}

const SemRegistros = ({ carregando, registros = 0, titulo, subtitulo }: Props): React.ReactElement =>
{
    return (
        <React.Fragment>
            { !carregando && !registros && (
                <div className="animate__animated animate__fadeIn d-flex flex-column flex-grow-1 justify-content-center align-items-center">
                    <AnimacaoNaoEncontrado />
                    <p className="text-white fs-1 fw-light text-center">
                        { titulo ? titulo : 'Nenhum registro encontrado' }
                    </p>
                    { subtitulo && (
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-md-5">
                                    <p className="lead text-muted text-center">
                                        { subtitulo }
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) }
                </div>
            ) }
        </React.Fragment>
    )
}

export default SemRegistros;
